import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import SettingCard from "../components/setting-card";
import { isElectron } from "../utils/platform";
import { roomStore } from "../stores/room";
import AgoraWebClient from "../utils/agora-rtc-client";
import { platform } from "../utils/platform";
import { useAuth } from "../services/auth-check";
import Language from "@material-ui/icons/Language";
import Button from "../components/custom-button";
import Icon from "../components/icon";
import GlobalStorage from "../utils/custom-storage";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { globalStore, roomTypes } from "../stores/global";
import { t } from "../i18n";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

function DeviceTest() {
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const [lang, setLang] = React.useState<string>("");
  const [, setHomeActive] = React.useState(false);
  const [, setProfile] = React.useState(false);
  const [, setSettings] = React.useState(false);

  const changelang = (lang: string) => {
    if (lang == "ar") {
      localStorage.setItem("language", `${JSON.stringify("ar")}`);
      document.documentElement.lang = "ar";
      globalStore.setLanguage("ar");
    } else {
      localStorage.setItem("language", `${JSON.stringify("en")}`);
      document.documentElement.lang = "en";
      globalStore.setLanguage("en");
    }
  };

  const handleConfirm = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("UserData");
    localStorage.removeItem("UserFullData");
    localStorage.removeItem("countryCode");
    history.push("/login");
    setOpen(false);
  };

  const handleClick2 = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = (evt: any) => {
    history.goBack();
  };

  useEffect(() => {
    const lang = GlobalStorage.getLanguage().language;

    setLang(lang);

    if (platform === "web") {
      const webClient = roomStore.rtcClient as AgoraWebClient;
      return () => {
        if (webClient.tmpStream) {
          webClient.tmpStream.isPlaying() && webClient.tmpStream.stop();
          webClient.tmpStream.close();
        }
      };
    }
  }, []);

  const [authorized, redirect] = useAuth("SETTINGS");

  if (!authorized) {
    redirect();
    return null;
  }

  return (
    <>
      <div className={`setting-container`}>
        <div
          onClick={(evt: any) => {
            handleClick2();
          }}
          className="logout-button"
        >
          <span style={{ color: "white", cursor: "pointer" }}>
            {t("logout")}
          </span>
          <Icon className="icon-exit-white home-" />
        </div>
        {lang == "ar" ? (
          <button className="lang-btn" onClick={() => changelang("en")}>
            <span>English</span>
            <Language />
          </button>
        ) : (
          <button className="lang-btn" onClick={() => changelang("ar")}>
            <span>عربي</span> <Language />
          </button>
        )}
      </div>
      <Dialog
        className="logout-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("areYouSureToLogOut")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} name={t("logout")} />
          <Button onClick={handleClose} name={t("close")} />
        </DialogActions>
      </Dialog>
      <div
        className={`flex-container test-device ${
          isElectron ? "draggable" : "home-cover-web"
        }`}
      >
        <div className="test-device">
          <div className="header">
            <div className="logo"></div>
          </div>
          <h2>{t("settings")}</h2>

          <SettingCard handleFinish={handleClick} />
          <div className={lang == "ar" ? "icons-ar icons" : "icons"}>
            <Icon
              className={"icon-home"}
              onClick={() => {
                history.push(`/`);
              }}
            />

            <Icon
              className={"icon-profile"}
              onClick={() => {
                history.push({ pathname: `/edit-profile` });
              }}
            />
            <Icon className={"icon-setting active"} />
          </div>
        </div>
      </div>
    </>
  );
}

export default React.memo(DeviceTest);
